import { Box, useTheme } from '@mui/material'
import { memo } from 'react'

import poweredByBlack from 'src/assets/powered-by-black.png'
import poweredByWhite from 'src/assets/powered-by-white.png'
import { THEME_MODE } from 'src/constants/theme'

const PoweredBy = () => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        mb: 1.25,
        mt: 1.25
      }}
    >
      <img
        alt='Powered by qiibee'
        src={
          theme.palette.mode === THEME_MODE.DARK
            ? poweredByWhite
            : poweredByBlack
        }
        style={{ height: 28 }}
      />
    </Box>
  )
}

export default memo(PoweredBy)
